import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { APP_FONT_FAMILY } from "../constants/typography";

const FinancePaymentSuccessContent = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ textAlign: "center", mt: 6, px: 2, maxWidth: 640, mx: "auto", fontFamily: APP_FONT_FAMILY }}>
      <CheckCircleIcon sx={{ fontSize: 64, color: "#4CAF50", mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {t("finance_payment_received") || "Payment received"}
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        {t("finance_payment_thank_you") || "Thank you. Your payment has been recorded."}
      </Typography>
    </Box>
  );
};

const FinancePaymentSuccess = () => <FinancePaymentSuccessContent />;

export default FinancePaymentSuccess;
